import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiCollection, getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import {
  CategoryImage,
  formatCategoriesImages,
} from "@/utils/formatCategoriesImages";
import { queryCategories } from "@/strapiQuery/categories";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layout = await getStrapiEntity<Layout>("layout", "");
  const intlMessages = loadIntlMessages(ctx);

  const categoriesImages = await getStrapiCollection<CategoryImage>(
    "categories",
    queryCategories
  ).then((categories) => {
    return formatCategoriesImages(categories);
  });

  return {
    props: {
      layout,
      categoriesImages,
      intlMessages,
      defaultCanonicalRoute: routes.account,
      requireAuth: true,
    },
    revalidate: 10,
  };
};

export { Account as default } from "@/components/pages/account/AccountB2B";
